export const GenericErrorBoundaryConstant = {
  Heading: 'Error',
  Subheading: "We're sorry an unexpected error has occurred.",
  ResetButtonLabel: 'Reload Page',
} as const
